import { AxiosResponse } from 'axios';
import { SignupPharmaceuticalParams } from '../pages/portal-pharmaceutical/signup/contracts';
import { authenticatedPostRequest } from './authenticatedRequestService';
import { IAuthUser } from '../pages/portal-pharmaceutical/common/contracts';
import envConfig from '../config/environment-config';

async function register(body: SignupPharmaceuticalParams): Promise<AxiosResponse<IAuthUser, any>> {
  const method = 'pharmaceuticals/signup';
  const requestBody = {
    ...body,
    originCode: envConfig.originCode,
  };

  return await authenticatedPostRequest(
    method,
    requestBody,
  );
}

export const signupPharmaceuticalService = {
  register,
};
